import React from "react";
import dateFormat from "dateformat";
import { Link } from "react-router-dom";
const SingleItem = ({ data }) => {
  return (
    <>
      <tr>
        <td data-label="Full Name">
          <Link to={`/admin/users/details/${data?.user_id?._id}`}>
            <span className="fw-bold">
              {data?.user_id?.fname} {data?.user_id?.lname}
            </span>
          </Link>
        </td>
        <td data-label="Email">
          <Link to={`/admin/users/details/${data?.user_id?._id}`}>
            <span className="fw-bold">{data?.user_id?.email}</span>
          </Link>
        </td>
        <td data-label="NFT Name">{data?.coin_id?.name}</td>

        <td data-label="NFT Symbol">{data?.coin_id?.symbol}</td>
        <td
          data-label={
            data?.type === "buy" || data?.type === "sell"
              ? "NFT"
              : "Remaining NFT"
          }
        >
          {data.coin_amount}
        </td>
        {data?.type === "buy" && (
          <>
            <td data-label="Buy/Sell">
              <span className="badge badge--success text-success">Buy</span>
            </td>
          </>
        )}
        {data?.type === "sell" && (
          <>
            <td data-label="Buy/Sell">
              <span className="badge badge--danger text-danger">Sell</span>
            </td>
          </>
        )}
        <td data-label="Created At">
          {dateFormat(data?.createdAt, "dd-mm-yyyy, h:MM:ss TT")}
        </td>
      </tr>
    </>
  );
};

export default SingleItem;
